import type { BurstFx, ChainFx } from '@/bosses/boss-hooks';

/**
 * Feedback for bespoke boss events (bosses/boss-hooks.ts): blast scale
 * ('big' = chain explosion), screen shake, explosion sfx volume, yellow
 * gems. 0 = channel off.
 */
export const BOSS_FEEDBACK = {
  /** Serpent: chain explosions + gem trail along the dying snake's body */
  serpentDeath: { blast: 0.9, shake: 16, sfx: 1.5, gems: 10, gemsAt: 'mid' },
  /** Kraken: severed-arm feedback (docs/12 C7), gems at the tip */
  krakenArm: { blast: 0.9, shake: 12, sfx: 1.3, gems: 6, gemsAt: 'tip' },
  /** Centipede: a clean split pops fx + a gem reward (docs/12 I1) */
  centipedeSplit: { blast: 1.1, shake: 10, sfx: 1.2, gems: 7 },
  /** Centipede: every dying node pops; a dying HEAD goes out with a bang (L4) */
  centipedeNode: { blast: 0.8, shake: 0, sfx: 0, gems: 0 },
  centipedeHead: { blast: 'big', shake: 14, sfx: 1.5, gems: 0 },
  /** Centipede: bursting out of its mound (docs/02 B2 burrow) */
  centipedeErupt: { blast: 1.0, shake: 9, sfx: 1.0, gems: 0 },
  /** Quartet: pair burnout feedback at 50% (docs/12 C6) */
  quartetClone: { blast: 'big', shake: 14, sfx: 1.4, gems: 6 },
  /** Warden: turret destruction */
  wardenPart: { blast: 1.2, shake: 10, sfx: 1.2, gems: 5 },
  /** Terra + Avatar earth phase: seismic slam shakes the screen (B8/B11) */
  slam: { blast: 'big', shake: 18, sfx: 1.4, gems: 0 },
  /** Carrier: a corner turret is destroyed (docs/02 B4) */
  carrierTurret: { blast: 1.1, shake: 8, sfx: 1.1, gems: 3 },
  /** Pyre: the meteor lands (docs/02 B2 dive) */
  pyreImpact: { blast: 1.4, shake: 12, sfx: 1.2, gems: 0 },
  /** Broodworm: each severed segment pops fx + gems (per-part HP boss) */
  broodwormSegment: { blast: 0.9, shake: 9, sfx: 1.1, gems: 4 },
  /** Splitter: each blob division pops fx + a small gem reward (B13) */
  splitterSplit: { blast: 0.8, shake: 8, sfx: 0.9, gems: 3 },
  /** Webspinner: a cocoon panel is shot apart (silk puff, no reward) */
  webspinnerTear: { blast: 0.45, shake: 3, sfx: 0.5, gems: 0 },
} as const satisfies Record<string, BurstFx | ChainFx>;
